import labels from "emun.media/_labels";

export default [
  // {
  //   radio: "Active",
  //   title: "Status",
  //   authorize: (s) => s.isRetailerOrAbove(),
  //   options: [
  //     {
  //       fieldName: "Active",
  //       label: "Active",
  //       value: () => true,
  //     },
  //     {
  //       fieldName: "Inactive",
  //       label: "Inactive",
  //       value: () => false,
  //     },
  //   ],
  // },
  {
    groupBy: "Active",
    title: labels.active || labels.status || "Active",
    formatter: (tag) => (tag.tagLabel === "false" ? "Inactive" : "Active"),
  },
  { groupBy: "ContentType", title: labels.contentType },
  { date: "LastModifiedOn", title: labels.lastModifiedOn },
  { date: "CreatedOn", title: labels.createdOn },
];
